<template>
    <vue-final-modal
        v-slot="{ close, params }"
        v-bind="$attrs"
        classes="modal_container"
        content-class="modal_wrapper"
        lock-scroll
        v-on="$listeners"
    >
        <div class="modal_content">
            <button type="button" class="modal_content_close" @click="close">
                <IconClose />
            </button>

            <div class="modal_content_container">
                <h2>{{ params?.title ?? 'Message' }}</h2>
                <p>{{ params.message }}</p>
            </div>
        </div>
    </vue-final-modal>
</template>

<script lang="ts">
export default {
    inheritAttrs: false,
};
</script>

<script setup lang="ts">
import IconClose from '@/components/icons/IconClose.vue';
</script>

<style scoped lang="scss">
.modal_content {
    background-color: #ffffff;
    position: relative;
    border-radius: 48px;
    padding: 40px;
    width: 620px;

    @media screen and (max-width: 1100px) {
        width: 520px;
        padding: 40px;
        border-radius: 30px;
    }

    @media screen and (max-width: 600px) {
        width: 420px;
    }

    @media screen and (max-width: 460px) {
        width: 320px;
    }

    &_container {
        h2 {
            color: #202020;
            font-family: "Bebas Neue Pro",serif;
            font-size: 40px;
            font-style: normal;
            font-weight: 700;
            line-height: 100%;
            text-transform: uppercase;
            margin: 0;
            padding: 0 0 22px;

            @media screen and (max-width: 1100px) {
                font-size: 30px;
                padding: 0 0 36px;
            }
            @media screen and (max-width: 767px) {
                padding: 0 0 28px;
            }
        }
    }

    &_close {
        border: none;
        outline: none;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #ffffff;
        position: absolute;
        bottom: calc(100% + 16px);
        right: 0;

        @media screen and (max-width: 767px) {
            width: 56px;
            height: 56px;
            bottom: calc(100% + 8px);
        }
    }
}
</style>
